import { render, staticRenderFns } from "./BrandUpdateScreen.vue?vue&type=template&id=3b784e2b&"
import script from "./BrandUpdateScreen.vue?vue&type=script&lang=js&"
export * from "./BrandUpdateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports